import dayjs from "dayjs";
// tableUtils.js
// Function to handle sorting when a column header sort icon is clicked
export const handleRequestSort = (
    order,
    orderBy,
    property,
    setOrder,
    setOrderBy
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

// Function to handle page change in the pagination
export const handleChangePage = (event, newPage, setPage) => {
    setPage(newPage);
  };

// Function to handle the change of rows per page
export const handleChangeRowsPerPage = (event, setRowsPerPage, setPage) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

// Function to compare two rows based on a column's value for descending order
export const descendingComparator = (a, b, orderBy, columns) => {
    // Old Logic
    // if (b[orderBy] < a[orderBy]) {
    //   return -1;
    // }
    // if (b[orderBy] > a[orderBy]) {
    //   return 1;
    // }
    // return 0;

    // const AUTH_DATA = JSON.parse(
    //   localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
    // );
    // const userDateFormat = AUTH_DATA?.dateFormat || "DD/MM/YYYY";
    // const userTimeZone = AUTH_DATA?.timeZone || "Asia/Kolkata";

    const column = columns.find((col) => col.id === orderBy);

    if (column?.isDate) {
      // Parse date strings to Date objects
      const dateA = dayjs(a[orderBy]);
      const dateB = dayjs(b[orderBy]);

      if (dateB.isBefore(dateA)) return -1;
      if (dateB.isAfter(dateA)) return 1;
      return 0;
    }
    
    // Default string/number comparison
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

// Function to get a comparator function based on the order and column
export const getComparator = (order, orderBy, columns = []) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy, columns)
      : (a, b) => -descendingComparator(a, b, orderBy, columns);
  };

// Function to perform stable sorting of an array based on a comparator
export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

// Function which will search the value into table
export const requestSearch = (searchedVal, RowData) => {
  const searchValue = searchedVal.toLowerCase();
  const searchInObject = (obj) => {
    return Object.values(obj).some((value) => {
      if (typeof value === "string" || typeof value === "number") {
        return String(value).toLowerCase().includes(searchValue);
      } else if (Array.isArray(value)) {
        return value.some(searchInObject);
      } else if (typeof value === "object" && value !== null) {
        return searchInObject(value);
      }
      return false;
    });
  };

  return RowData.filter(searchInObject);
};

// export const handleOutSideDataTableSearch = (searchedVal, originalData) => {
//   if (!searchedVal.trim()) {
//     return originalData; // Return all records when search field is empty
//   }

//   const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
//   const searchValue = escapeRegex(searchedVal.toLowerCase());
//   const searchRegex = new RegExp(`\\b${searchValue}\\b`, "i"); // Match whole word (case-insensitive)

//   const searchInObject = (obj) => {
//     return Object.values(obj).some((value) => {
//       if (typeof value === "string") {
//         return searchRegex.test(value); // Match full word using regex
//       } else if (typeof value === "number") {
//         return String(value) === searchValue; // Exact match for numbers
//       } else if (Array.isArray(value)) {
//         return value.some(searchInObject);
//       } else if (typeof value === "object" && value !== null) {
//         return searchInObject(value);
//       }
//       return false;
//     });
//   };

//   try {
//     return originalData.filter(searchInObject);
//   } catch (error) {
//     console.error("Search error:", error);
//     return []; // Return empty array if any error occurs
//   }
// };


export const handleOutSideDataTableSearch = (searchedVal, originalData) => {
  if (!searchedVal.trim()) {
    return originalData; // Return all records when search field is empty
  }

  const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
  const searchValue = escapeRegex(searchedVal.toLowerCase());
  const searchRegex = new RegExp(`\\b${searchValue}\\b`, "i"); // Match whole word (case-insensitive)

  // This function only considers top-level properties (ignores nested arrays/objects)
  const topLevelSearch = (obj) => {
    return Object.entries(obj).some(([key, value]) => {
      if (typeof value === "string") {
        return searchRegex.test(value);
      } else if (typeof value === "number") {
        return String(value) === searchValue;
      }
      // Ignore any nested objects, arrays, booleans, etc.
      return false;
    });
  };

  try {
    return originalData.filter(topLevelSearch);
  } catch (error) {
    console.error("Search error:", error);
    return []; // Return empty array if any error occurs
  }
};











